
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimelineMode } from '@simlab/data-access';
import { UserPreferenceFacade } from '@simlab/data-store';
import { DesignRadioAccordionModule } from '@simlab/design/accordion';
import { AppearanceForm } from '../appearance.component';

@Component({
    selector: 'simlab-timeline-mode',
    providers: [UserPreferenceFacade],
    imports: [
    DesignRadioAccordionModule,
    FormsModule,
    ReactiveFormsModule
],
    templateUrl: './timeline-mode.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./timeline-mode.component.scss']
})
export class TimelineModeComponent {
  @Input({ required: true }) formGroup!: FormGroup<AppearanceForm>;
  readonly timelineMode = TimelineMode;
}
